__turbopack_context__.v({
  "link-button": "Q-omMW_link-button",
  "link-button--as-text": "Q-omMW_link-button--as-text",
  "link-button--outline": "Q-omMW_link-button--outline",
  "link-button--primary": "Q-omMW_link-button--primary",
  "link-button--secondary": "Q-omMW_link-button--secondary",
  "link-button--tertiary": "Q-omMW_link-button--tertiary",
  "link-button--uppercase": "Q-omMW_link-button--uppercase",
  "link-button-icon": "Q-omMW_link-button-icon",
  "link-button-icon--extra-small": "Q-omMW_link-button-icon--extra-small",
  "link-button-icon--large": "Q-omMW_link-button-icon--large",
  "link-button-icon--medium": "Q-omMW_link-button-icon--medium",
  "link-button-icon--small": "Q-omMW_link-button-icon--small",
  "link-button__content": "Q-omMW_link-button__content",
  "link-button__content--has-icons": "Q-omMW_link-button__content--has-icons",
  "link-button__link-disabled": "Q-omMW_link-button__link-disabled",
});
